import { useEffect, useState } from "react";

const Q = "jixxeo_offline_launches";
const LP = "jixxeo_launcher_pending";
const read = (k, d) => { try { return JSON.parse(localStorage.getItem(k)) ?? d; } catch { return d; } };
const write = (k, v) => { try { v == null ? localStorage.removeItem(k) : localStorage.setItem(k, JSON.stringify(v)); } catch {} };

export const queueLaunch = (slug) => write(Q, [...read(Q, []), { slug, at: new Date().toISOString() }].slice(-200));
export const pendingLauncher = () => read(LP, null);
export const setPendingLauncher = (v) => write(LP, v);

export async function flushOffline(api) {
  if (!navigator.onLine) return;
  const q = read(Q, []);
  write(Q, []);
  const failed = [];
  for (const l of q) {
    try { await api.post(`/apps/${l.slug}/launch`, { client_id: localStorage.getItem("jixxeo_cid") || "", at: l.at }); }
    catch (e) { if (!e.response) failed.push(l); }
  }
  if (failed.length) write(Q, [...failed, ...read(Q, [])]);
  const p = pendingLauncher();
  if (p) {
    try { await api.put("/launcher", p); setPendingLauncher(null); window.dispatchEvent(new Event("jixxeo-launcher-synced")); }
    catch (e) { if (e.response) setPendingLauncher(null); }
  }
}

export function useOnline() {
  const [on, setOn] = useState(typeof navigator === "undefined" ? true : navigator.onLine);
  useEffect(() => {
    const up = () => setOn(true), down = () => setOn(false);
    window.addEventListener("online", up); window.addEventListener("offline", down);
    return () => { window.removeEventListener("online", up); window.removeEventListener("offline", down); };
  }, []);
  return on;
}
